// Detects whether pasted text is a YouTube *video* URL (vs. a plain search
// query). Broader than parseVideoLink's platform regexes in one way — the
// smart input accepts protocol-less pastes ("youtube.com/watch?v=...") — and
// narrower in another: channel/handle URLs are treated as search text.
const YOUTUBE_VIDEO_URL_REGEX =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?|shorts\/|live\/)|youtu\.be\/)[^\s/]/;

export function isYoutubeVideoUrl(input: string): boolean {
  return YOUTUBE_VIDEO_URL_REGEX.test(input.trim());
}
